'use client'
import { FaDiscord } from 'react-icons/fa6'

import { SidebarFooter as SidebarFooterOriginal, SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar"
import { NavUser } from "./nav-user"
import { useAuth } from "@/hooks/use-auth"
import { DropdownMenu, DropdownMenuTrigger } from './ui/dropdown-menu'

export const SidebarFooter = () => {
  const { user, signIn } = useAuth()

  return (
    <SidebarFooterOriginal>
      {user && (<NavUser user={user} />)}
      {!user && (
        <SidebarMenu>
          <SidebarMenuItem>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <SidebarMenuButton onClick={signIn} size='lg' variant="secondary" tooltip="Sign In with Discord">
                  <div className="h-8 flex items-center justify-center pl-[calc(var(--spacing)*1.124))]">
                    <FaDiscord className="w-6 h-6 rounded-lg" />
                  </div>
                  <span>Sign In with Discord</span>
                </SidebarMenuButton>
              </DropdownMenuTrigger>
            </DropdownMenu>
          </SidebarMenuItem>
        </SidebarMenu>
      )}
    </SidebarFooterOriginal>
  )
}